export type TradeState =
    | "SUCCESS"
    | "REFUND"
    | "NOTPAY"
    | "CLOSED"
    | "REVOKED"
    | "USERPAYING"
    | "PAYERROR";

export type IWxOrder = {
    /**
     * 订单id
     */
    id: number;
    /**
     * 订单用户id
     */
    userId: number;
    /**
     * 商品描述
     */
    description: string;
    /**
     * 订单总金额，单位为分
     */
    totalAmount: number;
    /**
     * 交易状态，枚举值：SUCCESS：支付成功，
     * REFUND：转入退款，NOTPAY：未支付，CLOSED：已关闭，
     * REVOKED：已撤销（付款码支付），USERPAYING：用户支付中（付款码支付），
     * PAYERROR：支付失败(其他原因，如银行返回失败)
     */
    tradeState: TradeState;
    /**
     * api_type为NATIVE支付时(pc端扫码支付属于NATIVE类型)，成功返回的code_url
     */
    qrCodeUrl?: string;
    /**
     * trade_type为"APP"且支付成功时返回的prepay_id
     */
    prepayId?: string;
    /**
     * trade_type为"MWEB"且支付成功时返回的h5_url
     */
    h5Url?: string;
    /**
     * 信息创建时间
     */
    createdAt: number;
};

export class WxOrder implements IWxOrder {
    /**
     * 订单id
     */
    id!: number;
    /**
     * 订单用户id
     */
    userId!: number;
    /**
     * 商品描述
     */
    description!: string;
    /**
     * 订单总金额，单位为分
     */
    totalAmount!: number;
    /**
     * 交易状态，枚举值：SUCCESS：支付成功，
     * REFUND：转入退款，NOTPAY：未支付，CLOSED：已关闭，
     * REVOKED：已撤销（付款码支付），USERPAYING：用户支付中（付款码支付），
     * PAYERROR：支付失败(其他原因，如银行返回失败)
     */
    tradeState!: TradeState;
    /**
     * api_type为NATIVE支付时(pc端扫码支付属于NATIVE类型)，成功返回的code_url
     */
    qrCodeUrl?: string;
    /**
     * trade_type为"APP"且支付成功时返回的prepay_id
     */
    prepayId?: string;
    /**
     * trade_type为"MWEB"且支付成功时返回的h5_url
     */
    h5Url?: string;
    /**
     * 信息创建时间
     */
    createdAt!: number;

    constructor(wxOrder: IWxOrder) {
        Object.assign(this, wxOrder);
    }

    get tradeStateText() {
        switch (this.tradeState) {
            case "CLOSED":
                return "订单已关闭";
            case "NOTPAY":
                return "订单未支付";
            case "PAYERROR":
                return "订单支付失败";
            case "REFUND":
                return "订单已转入退款流程";
            case "REVOKED":
                return "订单已撤销";
            case "SUCCESS":
                return "订单支付成功";
            case "USERPAYING":
                return "订单支付中...";
        }
    }
}
